// Recovery credentials stay in component memory and are never retried automatically.
export function newRecoveryRequestId(random = window.crypto) {
  if (!random || !random.getRandomValues) throw new Error('Peramban tidak mendukung ID pemulihan yang aman.');
  const bytes = new Uint8Array(16);
  random.getRandomValues(bytes);
  bytes[6] = (bytes[6] & 15) | 64; bytes[8] = (bytes[8] & 63) | 128;
  const hex = Array.from(bytes, b => b.toString(16).padStart(2, '0')).join('');
  return hex.slice(0,8)+'-'+hex.slice(8,12)+'-'+hex.slice(12,16)+'-'+hex.slice(16,20)+'-'+hex.slice(20);
}
export function recoveryFailure(error) {
  const status = error && error.response && error.response.status;
  if (recoveryReloadRequired(error)) return 'Muat ulang halaman sebelum melanjutkan. Belum ada perubahan data.';
  if (status === 401) return 'Sesi berakhir. Silakan masuk kembali.';
  if (status === 403) return 'Tidak berhak memulihkan akun siswa ini.';
  if (status === 400) return 'Pilihan siswa atau ID permintaan tidak sah.';
  if (status === 429) return 'Siswa ini baru direset. Tunggu satu menit dan periksa hasil sebelumnya.';
  if (status === 404) return 'Receipt belum ditemukan. Jangan mengulang otomatis; periksa kembali.';
  return 'Hasil belum dapat dipastikan. Tekan Periksa hasil sebelum membuat permintaan baru.';
}
export async function submitRecovery(api, request) {
  const response = await api.post('/siswa/pulihkanPassword', request, {
    timeout:20000, headers:{'X-Requested-With':'EduPrimePasswordFormats/alnum9-v1'}
  });
  const body = response && response.data;
  // Receive-only compatibility while old and new servers overlap during rollout/rollback.
  // Nine lowercase letters/digits covers the mixed format and the nine digits issued since 29 Oct.
  if (!body || !body.errorSchema || body.errorSchema.errorCode !== 'EP-000'
      || !body.data || body.data.requestId !== request.requestId || body.data.status !== 'COMPLETED'
      || typeof body.data.password !== 'string'
      || !((body.data.password.length === 9 && /^[a-z0-9]{9}$/.test(body.data.password))
        || (body.data.password.length === 20 && /^[ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz23456789]{20}$/.test(body.data.password))))
    throw new Error('Hasil belum dapat dipastikan.');
  return body.data;
}
export function recoveryReloadRequired(error) {
  const response = error && error.response;
  return !!(response && response.status === 428 && response.data && response.data.errorSchema
    && response.data.errorSchema.errorCode === 'EP-428');
}
export async function checkRecovery(api, requestId) {
  const response = await api.get('/siswa/pemulihanPassword/' + encodeURIComponent(requestId), {timeout:10000});
  const body = response && response.data;
  if (!body || !body.errorSchema || body.errorSchema.errorCode !== 'EP-000'
      || !body.data || body.data.requestId !== requestId || body.data.status !== 'COMPLETED')
    throw new Error('Hasil belum dapat dipastikan.');
  // Status responses are never allowed to rehydrate a credential, even from a broken server.
  return {requestId, status: 'COMPLETED', completedAt: body.data.completedAt, sessionsRevoked: body.data.sessionsRevoked === true};
}
